/*
 * $Id:: Header.js 2021/02/26 06:09 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import React, { useState, useEffect } from 'react';

import AppBar from '@material-ui/core/AppBar';
import Link from '@material-ui/core/Link';
import { makeStyles } from '@material-ui/core/styles';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { ReactComponent as LogoIcon } from '../../assets/images/logo-image-file.svg';
import { ReactComponent as VPBLogo } from '../../assets/images/vpb_logo.svg';
import { deleteCookie, deleteLocalStorage, getLocalStorage, setLocalStorage } from '../../common/utils';
import { me as meSlice } from '../../pages/AuthenticatedPage/authenticationSlice';
import { SLICE_NAME } from '../../pages/AuthenticatedPage/constants';
import { details as detailsSlice } from '../../pages/MyAccountPage/accountSlice';
import helpers from '../../pages/SSOPage/SSOHelpers';
import ConfirmLogoutDialog from './ConfirmLogoutDialog';
import DrawerSidebar from './DrawerSidebar';
import UserInfo from './UserInfo';
import UserinfoMobile from './UserInfoMobile';

const useStyles = makeStyles((theme) => ({
    headerWrapper: {
        backgroundColor: '#ffffff',
        boxShadow: '0px 3px 3px rgba(0, 0, 0, 0.1)',
        height: '85px',
    },
    header: {
        color: theme.palette.action,
        padding: '0 20px',
        width: '100%',
        display: 'flex',
        flexFlow: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        '@media (max-width:960px)': {
            padding: '0 20px',
        },
    },
    headerToolbar: {
        minHeight: '85px',
        '@media (max-width: 960px)': {
            paddingLeft: 'unset',
            paddingRight: 'unset',
        },
    },
    logoLink: {
        cursor: 'pointer',
    },
    leftSection: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
    },
}));

const Header = ({ smallDevice }) => {
    const classes = useStyles();
    const me = useSelector(meSlice);
    const dispatch = useDispatch();
    const history = useHistory();
    const details = useSelector(detailsSlice);

    const [dialogOpen, setDialogOpen] = useState(false);
    const [user, setUser] = useState({
        fullName: (me || {}).fullName,
        role: (me || {}).personType,
        userType: (me || {}).userType,
    });

    useEffect(() => {
        const user = me || {};
        setUser({
            fullName: user.fullName || '',
            userRole: user.personType || '',
            userType: user.userType || '',
            userDetails: details || {},
        });
    }, [me, details]);

    const isLoggedIn = !!(me || {}).userName;
    const impersonated = !!(me || {}).impersonatedUser;

    const logout = (_event) => {
        setDialogOpen(false);
        if (impersonated) {
            deleteCookie('ACTIVE_IMPERSONATION');
            dispatch({ type: `${SLICE_NAME}/impersonatedUserLogout` });
        } else {
            helpers.logout();
        }
    };

    const navigateToHomepage = (event) => {
        event.preventDefault();
        dispatch({ type: `${SLICE_NAME}/error`, payload: null });
        history.push('/');
    };

    const initiateLogout = () => {
        setDialogOpen(true);
    };

    const cancelLogout = (event) => {
        event.preventDefault();
        setDialogOpen(false);
    };

    useEffect(() => {
        if (me && !!Object.keys(me).length) {
            const finalizeImpersonation = getLocalStorage('finalizeImpersonation') || false;
            deleteLocalStorage(['finalizeImpersonation']);
            if (!impersonated && finalizeImpersonation) {
                window.close();
            }
        }
    }, [me]);

    useEffect(() => {
        return () => {
            window.addEventListener('beforeunload', function (e) {
                if (!impersonated) return;
                e.preventDefault();
                logout();
                setLocalStorage([{ item: 'finalizeImpersonation', value: true }]);
            });
        };
    });

    return (
        <AppBar className={classes.headerWrapper} data-testid="HeaderTestId">
            <Toolbar className={classes.headerToolbar}>
                <div className={classes.header}>
                    <div className={classes.leftSection}>
                        {smallDevice && <DrawerSidebar />}
                        <div className={classes.logo}>
                            <Typography variant="h4">
                                <Link onClick={navigateToHomepage} id="logo" className={classes.logoLink}>
                                    <VPBLogo />
                                </Link>
                            </Typography>
                        </div>
                    </div>
                    {isLoggedIn &&
                        (smallDevice ? <UserinfoMobile user={user} logout={initiateLogout} /> : <UserInfo user={user} logout={initiateLogout} />)}
                </div>
            </Toolbar>
            {dialogOpen && <ConfirmLogoutDialog open={dialogOpen} onAccept={logout} onCancel={cancelLogout} />}
        </AppBar>
    );
};

export default Header;
